// extracted by mini-css-extract-plugin
module.exports = {"animated__background":"SqueletonPlaceholder_animated__background__q9lvl","placeHolderShimmer":"SqueletonPlaceholder_placeHolderShimmer__pdBok"};